import{TextRestrictionFields as e}from"../../../types/restrictionsTypes.js";const t=({message:t})=>t?{type:"text_message",[e.TEXT]:t.text_message?.text}:null;export{t as getTextDetails};
//# sourceMappingURL=getTextDetails.js.map
